import {
  SET_FILE_LOGS_DATA,
  SET_FILE_LOGS_LOADING,
  SHOW_BATCH_FILE_UPLOAD_MODAL,
  HIDE_BATCH_FILE_UPLOAD_MODAL,
  SET_BATCH_FILE_UPLOAD_LOADING,
  SET_BATCH_FILE_UPLOAD_DATA,
  UPDATE_PAGINATION,
  SET_JOB_QUEUE_LOADING_STATE,
  SET_JOB_QUEUE_DATA,
  SET_PAGE,
  UPDATE_JOB_QUEUE_DATA,
  RESET_SEARCH_VALUE,
  RESET_FILTER_FIELD,
} from './mutation-types';
import {capitalize} from 'lodash';

export default {

  [SET_FILE_LOGS_LOADING](state, loading) {
    state.fileLogs.loading = loading;
  },

  [SET_FILE_LOGS_DATA](state, folders) {
    state.fileLogs.loaded = true;
    state.fileLogs.data = folders;

    // Get unique status options for table filter
    const batchUploadStatusName = [...new Set(folders.batchLogs.map(item => item.BatchUploadStatusName))];
    const batchFileStatusName = [...new Set(folders.batchFileLogs.map(item => item.BatchFileStatusName))];

    state.fileLogs.batchUploadOptions = batchUploadStatusName.map(item => ({
      value: item,
      text: capitalize(item),
    }));
    state.fileLogs.batchFileUploadOptions = batchFileStatusName.map(item => ({
      value: item,
      text: capitalize(item),
    }));
    state.fileLogs.batchUploadOptions.unshift({value: 'all', text: 'All'});
    state.fileLogs.batchFileUploadOptions.unshift({value: 'all', text: 'All'});

  },

  [SHOW_BATCH_FILE_UPLOAD_MODAL]: state => state.fileLogs.batchFileUploadModalShow = true,

  [HIDE_BATCH_FILE_UPLOAD_MODAL]: state => state.fileLogs.batchFileUploadModalShow = false,

  [SET_BATCH_FILE_UPLOAD_LOADING](state, loading) {
    state.fileLogs.batchFileUploadLoading = loading;
  },

  [SET_BATCH_FILE_UPLOAD_DATA](state, {data, id}) {
    state.fileLogs.batchFileUploadData = data.ResultSetTemp.map(function (b) {
      const newColumn = Object.assign({}, b);
      newColumn.BatchFileUploadId = id;
      return newColumn;
    });
    state.fileLogs.batchFileUploadErrors = data.Errors.length > 0 ? data.Errors.map(error => error).join(' ') : '';
  },

  [UPDATE_PAGINATION](state, {data}) {
    state.pagination = {...state.pagination, ...data};
  },
  // Define the mutations for the jobQueue module
  [SET_JOB_QUEUE_LOADING_STATE](state, payload) {
    state.jobQueue.isLoading = payload;
  },
  [SET_JOB_QUEUE_DATA](state, payload) {
    state.jobQueue.data = payload;
  },
  [SET_PAGE](state, page) {
    state.jobQueue.page = page;
  },
  [UPDATE_JOB_QUEUE_DATA](state, payload) {
    state.jobQueue.filteredData = payload;
  },
  [RESET_SEARCH_VALUE](state, payload) {
    state.jobQueue.searchValue = payload;
  },
  [RESET_FILTER_FIELD](state, payload) {
    state.jobQueue.filterField = payload;
  },
};
